import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInputGroup, TextInputGroupMain } from '@patternfly/react-core';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useSuggestions } from '../hooks/suggestions';
const STRING_SCHEMA = { type: 'string' };
export const KeyValueField = forwardRef(({ id, name, placeholder, value, 'data-testid': dataTestId, onChange, onFocus, onBlur }, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const suggestions = useSuggestions({
        propName: name,
        schema: STRING_SCHEMA,
        inputRef,
        value: value !== null && value !== void 0 ? value : '',
        setValue: onChange,
    });
    return (_jsxs(TextInputGroup, { children: [_jsx(TextInputGroupMain, { type: "text", id: id, name: name, "data-testid": dataTestId, onChange: (_event, value) => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(value);
                }, ref: inputRef, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder, value: value }), suggestions] }));
});
//# sourceMappingURL=KeyValueField.js.map